module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-5.af2a58c3.png";